import { render } from "./MainBlock.vue?vue&type=template&id=6a7f31ec&scoped=true"
import script from "./MainBlock.vue?vue&type=script&lang=js"
export * from "./MainBlock.vue?vue&type=script&lang=js"

import "./MainBlock.vue?vue&type=style&index=0&id=6a7f31ec&scoped=true&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a7f31ec"]])

export default __exports__